import axios from 'axios';
import { config } from './constants';
import { authDetails } from '../helpers/auth-details';

export function getAxiosInstance(host) {
    // Set config defaults when creating the instance

    if (!host) {
        host = config.HOST
    }

    var instance = axios.create({
        baseURL: host
    });

    const user = authDetails();
    // Alter defaults after instance has been created
    instance.defaults.headers.common['Authorization'] = user.token ? user.token : null;

    return instance;
};

export function axiosInstance(host) {
    // Set config defaults when creating the instance

    if (!host) {
        host = config.E_HOST
    }

    var instance = axios.create({
        baseURL: host
    });

    const user = authDetails();
    // Alter defaults after instance has been created
    instance.defaults.headers.common['Authorization'] = user.token ? user.token : null;

    return instance;
} 


// WEBPACK FOOTER //
// ./src/configs/axios-config.js